import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetServicePurchaseModelsDataTypes } from "../../../../Schema/getServicePurchaseModels.types";
import { setDiscountCode } from "../../discountCode/discountCode";

export type GetServicePurchaseModelsLoadAction = {
  type: string;
  payload: { id: number | string; discount_code?: string };
};

export type GetServicePurchaseModelsData = {
  data: GetServicePurchaseModelsDataTypes[];
};

const GetServicePurchaseModels = new ReduxFetchState<
  GetServicePurchaseModelsData,
  { id: number | string; discount_code?: string },
  any
>("getServicePurchaseModels");

export function* watchGetServicePurchaseModels(
  action: GetServicePurchaseModelsLoadAction,
) {
  try {
    const { id, discount_code } = action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetServicePurchaseModelsData = yield axios({
      url: `/api/v1/ai/service/${id}/purchase-model${discount_code ? "?discount_code=" + discount_code : ""}`,
      method: "GET",
      headers: {
        lang,
      },
    });

    if (discount_code) {
      yield put(
        setDiscountCode({ code: discount_code, type: "purchaseModel" }),
      );
    }
    yield put(
      GetServicePurchaseModels.actions.loadSuccess({ data: data.data }),
    );
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetServicePurchaseModels.actions.loadFailure(e.message));
  }
}

export function* getServicePurchaseModelsSagas() {
  yield takeEvery(
    GetServicePurchaseModels.actionTypes.load,
    watchGetServicePurchaseModels,
  );
}

export function useGetServicePurchaseModels() {
  const { loading, data, ...getServicePurchaseModelsState } = useAppSelector(
    (state) => state.getServicePurchaseModels,
  );
  const dispatch = useAppDispatch();

  const dispatchGetServicePurchaseModels = useCallback(
    (data: {
      id: number | string;
      discount_code?: string;
      isSilent?: boolean;
    }) => {
      dispatch(GetServicePurchaseModels.actions.load(data, data.isSilent));
    },
    [dispatch],
  );

  return {
    ...getServicePurchaseModelsState,
    dispatchGetServicePurchaseModels,
    getServicePurchaseModelsLoading: loading,
    getServicePurchaseModelsData: data,
  };
}

export const {
  actionTypes: getServicePurchaseModelsActionsTypes,
  actions: getServicePurchaseModelsActions,
  reducer: getServicePurchaseModelsReducer,
} = GetServicePurchaseModels;
